import { ShieldCheck } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export function EmptyState({
  icon: Icon,
  message,
}: {
  icon: typeof ShieldCheck;
  message: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-slate-400 dark:text-slate-600">
      <Icon className="w-10 h-10 mb-3 opacity-40" />
      <p className="text-sm">{message}</p>
    </div>
  );
}

export function LoadingSkeleton() {
  return (
    <div className="p-6 space-y-3">
      {Array.from({ length: 8 }).map((_, i) => (
        <Skeleton key={i} className="h-10 w-full" />
      ))}
    </div>
  );
}
